import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrderService } from 'src/app/services/order/order.service';

export type OrderStatus =
  | 'PENDING'
  | 'CONFIRMED'
  | 'PROCESSING'
  | 'SHIPPED'
  | 'DELIVERED'
  | 'CANCELLED';

export interface OrderListItem {
  id: string;
  orderNumber: string;
  status: OrderStatus;
  createdAt: string;
  total: number;
  items: { productName: string; quantity: number; imageUrl: string | null }[];
}

type FilterTab = 'ALL' | OrderStatus;

@Component({
  selector: 'app-myorders',
  templateUrl: './myorders.component.html',
  styleUrls: ['./myorders.component.css'],
})
export class MyordersComponent implements OnInit {
  allOrders: OrderListItem[] = [];
  filteredOrders: OrderListItem[] = [];
  activeFilter: FilterTab = 'ALL';
  isLoading = true;

  tabs: { key: FilterTab; label: string }[] = [
    { key: 'ALL', label: 'All' },
    { key: 'PENDING', label: 'Pending' },
    { key: 'CONFIRMED', label: 'Confirmed' },
    { key: 'PROCESSING', label: 'Processing' },
    { key: 'SHIPPED', label: 'Shipped' },
    { key: 'DELIVERED', label: 'Delivered' },
    { key: 'CANCELLED', label: 'Cancelled' },
  ];

  constructor(
    private orderService: OrderService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.loadOrders();
  }

  loadOrders(): void {
    this.orderService.getMyOrder().subscribe({
      next: (res: any) => {
        this.allOrders = res;
        this.applyFilter('ALL');
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading orders:', err);
        this.isLoading = false;
      },
    });
  }

  applyFilter(filter: FilterTab): void {
    this.activeFilter = filter;
    this.filteredOrders =
      filter === 'ALL'
        ? this.allOrders
        : this.allOrders.filter((o) => o.status === filter);
  }

  formatDate(iso: string): string {
    return new Date(iso).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  totalItems(order: OrderListItem): number {
    return order.items.reduce((acc, i) => acc + i.quantity, 0);
  }

  goToDetails(order: OrderListItem): void {
    this.router.navigate(['/profile/order-details', order.id]);
  }

  trackByOrder(_: number, order: OrderListItem): string {
    return order.id;
  }

  goBack(): void {
    this.router.navigate(['/profile/']);
  }

  get isRTL(): boolean {
    return document.documentElement.dir === 'rtl';
  }
}
